<template>
  <div>
    <div class="flex justify-between mb-4">
      <h2 class="text-2xl font-bold">Export</h2>
      <base-button @click="addNewOpen = !addNewOpen" :disabled="fetching">
        <span v-if="addNewOpen">Cancel</span>
        <span v-else><icon-plus /> Add new</span>
      </base-button>
    </div>

    <admin-segment-export-form
      v-if="addNewOpen"
      @saved="addNewOpen = false"
      class="mb-8"
    />

    <div v-if="fetching" class="text-blue-400">
      <base-loading class="block text-3xl" />
      Loading
    </div>
    <base-notice v-else-if="exportList.length === 0" class="my-12">
      No exports were added yet
    </base-notice>
    <ul v-else class="my-12">
      <li v-for="exportItem in exportList" :key="exportItem.id" class="mb-1">
        <div class="flex bg-white">
          <div class="flex-1 flex justify-between py-2 px-4">
            {{ exportItem.name }}
          </div>
          <div class="flex">
            <base-button
              @click="exportNow(exportItem.id)"
              type="button"
              theme="gray"
              class="mr-3"
            >
              Export now
            </base-button>
            <base-button
              @click="exportItem.editing = !exportItem.editing"
              type="button"
            >
              <icon-edit />
            </base-button>
          </div>
        </div>
        <div class="flex bg-white border-t border-gray-200">
          <div class="text-xs font-mono py-2 px-4">
            <icon-link class="text-sm align-middle mb-1 mr-2" />
            <span class="italic">Export target:</span>
            {{ exportItem.export_target.identifier }}
          </div>
        </div>

        <admin-segment-export-form
          v-if="exportItem.editing"
          :exportItem="exportItem"
          @saved="exportItem.editing = false"
          class="mb-8"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import { computed, onMounted, ref, watch } from '@vue/composition-api';
import AdminSegmentExportForm from './components/AdminSegmentExportForm.vue';

export default {
  components: { AdminSegmentExportForm },
  setup(props, { root }) {
    const companyId = computed(() => root.$store.state.company.currentId);
    const segmentId = computed(
      () => root.$store.state.company.segment.currentId
    );
    const fetching = computed(
      () =>
        root.$store.state.company.exports.fetching ||
        root.$store.state.company.segment.exports.fetchingList
    );
    const exportList = computed(
      () => root.$store.state.company.segment.exports.list
    );
    const addNewOpen = ref(false);

    watch(segmentId, () => {
      root.$store.dispatch('company/exports/fetchExports');
      root.$store.dispatch('company/segment/exports/fetchExports');
    });
    onMounted(() => {
      root.$store.dispatch('company/exports/fetchExports');
      root.$store.dispatch('company/segment/exports/fetchExports');
    });

    const exportNow = (id) => {
      // TODO launch export
      root.$api.post(
        `companies/${companyId.value}/segments/${segmentId.value}/exports/${id}/export_now`
      );
    };

    return {
      fetching,
      exportList,
      addNewOpen,
      exportNow,
    };
  },
};
</script>
